import { render, staticRenderFns } from "./alterReport.vue?vue&type=template&id=56085e51&scoped=true&"
import script from "./alterReport.vue?vue&type=script&lang=js&"
export * from "./alterReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56085e51",
  null
  
)

export default component.exports